import { checkResponse, get } from '../helpers/http'

export function getSettings () {
  return get('/settings')
    .then(checkResponse)
}